import { formatHistoricalDate } from "rant-utils";

export function HistoricalDate(props: {
	dt: string,
}) {
	const val = formatHistoricalDate(props.dt);
	let cls = "";
	if (val === "Just now") {
		cls = "recent-0";
	} else if (val.indexOf("minute") > 0) {
		cls = "recent-1";
	} else if (val.indexOf("hour") > 0) {
		cls = "recent-2";
	}

	return <div className={"tag " + cls}>{val}</div>;
}